module.exports = __webpack_public_path__ + "assets/img/addressNodata.b71ebd8a.png";